import React from "react"

import { useSelector } from "react-redux"

import { Models } from "../features/Models"
import { ModelsLayout } from "../layouts/ModelsLayout"
import type { RootState } from "../store/ReduxStore"

/**
 * Decision engines component
 * home to Konan Decision engines
 * Models, Rulesets, Workflows, Scorecards, Model Configuration
 * @return {React.ReactElement}
 */
export function DecisionEngines(): React.ReactElement {
  const currentModel = useSelector((state: RootState) => state.models.currentModel)

  // Use the new modelsLayout and give it the new sidebar but not the header because the new header is not implemented yet
  return (
    <ModelsLayout sidebarVariant="models" isSidebarOpen={!!currentModel?.uuid}>
      <Models />
    </ModelsLayout>
  )
}
